(function() {
  console.log('[Disclaimer] Script global cargado');
  
  function updateButtonState() {
    var btn = document.getElementById('checkout');
    var checkbox = document.getElementById('stock-disclaimer');
    
    if (!btn || !checkbox) return;
    
    var tieneKeychain = checkbox.dataset.tieneKeychain === 'true';
    var tieneJersey = checkbox.dataset.tieneJersey === 'true';
    var bundleError = tieneKeychain && !tieneJersey;
    
    // Botón habilitado solo si: checkbox marcado Y no hay error de bundle
    btn.disabled = !checkbox.checked || bundleError;
    
    console.log('[Disclaimer] Estado - checked:', checkbox.checked, 
                'keychain:', tieneKeychain, 'jersey:', tieneJersey,
                'bundleError:', bundleError, 'disabled:', btn.disabled);
  }
  
  function bindDisclaimer() {
    var btn = document.getElementById('checkout');
    var checkbox = document.getElementById('stock-disclaimer');
    
    if (!btn || !checkbox) return false;
    
    // Si ya está inicializado, solo re-evaluar el estado (por si cambió el carrito)
    if (checkbox.dataset.bound === 'true') {
      updateButtonState();
      return true;
    }
    
    checkbox.dataset.bound = 'true';
    checkbox.checked = false;
    
    checkbox.addEventListener('change', updateButtonState);
    
    updateButtonState();
    console.log('[Disclaimer] Vinculado correctamente');
    
    return true;
  }
  
  // Observer global que detecta cambios en el DOM
  var observer = new MutationObserver(function() {
    var checkbox = document.getElementById('stock-disclaimer');
    if (checkbox) {
      if (checkbox.dataset.bound !== 'true') {
        bindDisclaimer();
      } else {
        // Si el checkbox ya estaba pero el carrito cambió, re-evaluar
        updateButtonState();
      }
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
  
  // Intento inicial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindDisclaimer);
  } else {
    bindDisclaimer();
  }
})();